import React, { useReducer, useContext, useState, useEffect } from "react";
import Input from "../../atoms/Input";
import Button from "../../atoms/Button";
import toast from "react-hot-toast";
import { otpRequest } from "../../../utils/API/otpRequest";
import { verifyOtp } from "../../../utils/API/verifyOtp";
import { ReactComponent as Mail } from "../../svgs/mail.svg";
import { ReactComponent as Key } from "../../svgs/key.svg";
import { ReactComponent as Eye } from "../../svgs/eye.svg";
import { ReactComponent as Office } from "../../svgs/office.svg";
import { signUp } from "../../../utils/API/signUp";
import { TopLoaderContext } from "../../../context/TopLoader";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

const initialState = {
  companyName: "",
  email: "",
  code: "",
  password: "",
  reTypePassword: "",
  isCodeSent: false,
  isVerified: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "RESET":
      return initialState;
    case "UPDATE_FIELD":
      return { ...state, [action.field]: action.value };
    default:
      return state;
  }
};

function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

const SignupForm = ({ userType }) => {
  const params = useParams();
  const reduxDispatch = useDispatch();
  const navigate = useNavigate();

  const [timer, setTimer] = useState(0);  // Timer state
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);  
  const [otp, setOtp] = useState('');  // Otp code
  const [
    {
      companyName,
      email,
      code,
      password,
      reTypePassword,
      isCodeSent,
      isVerified,
    },
    dispatch,
  ] = useReducer(reducer, initialState);

  const { loadingRef } = useContext(TopLoaderContext);

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else {
      setIsButtonDisabled(false); // Enable the button when timer ends
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleInputChange = (field, value) => {
    dispatch({ type: "UPDATE_FIELD", field, value });
  };

  const onSendCode = async () => {
    const emailID = email.trim();
    if (emailID === "") {
      toast.error("Please fill out email field");
      return;
    } else if (validateEmail(emailID)) {
      try {
        loadingRef.current.continuousStart();
        await otpRequest({ email, userType }, reduxDispatch);
        loadingRef.current.complete();
        toast.success("Code has been sent!");
        dispatch({ type: "UPDATE_FIELD", field: "isCodeSent", value: true });
        setIsButtonDisabled(true); // Disable the button
        setTimer(60);
      } catch (err) {
        loadingRef.current.complete();
        toast.error(err.message);
      }
    } else {
      toast.error("Please enter valid email");
    }
  };

  const verificationHandler = async () => {
    try {
      loadingRef.current.continuousStart();
      await verifyOtp({ code, email, userType }, reduxDispatch);
      loadingRef.current.complete();
      dispatch({ type: "UPDATE_FIELD", field: "isVerified", value: true });
      toast.success("Verified");
    } catch (err) {
      loadingRef.current.complete();
      toast.error(err.message);
    }
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!isCodeSent) {
      toast.error("Please fill verify email");
      return;
    }
   
    if (otp === '' ) {
      toast.error("Please fill out otp field");
      return;
    }else if (otp.length !==4 ) {
      toast.error("Please fill coreact otp");
      return;
    }

    if (email === "") {
      toast.error("Please fill out email field");
      return;
    }

    if (password !== reTypePassword) {
      toast.error("Passwords should be same");
      return;
    }
    try {
      loadingRef.current.continuousStart();
      await signUp({ companyName, email, password, userType , otp }, reduxDispatch);
      loadingRef.current.complete();
      toast.success("Registeration Successful");
      navigate(`/${params.userType}`);
      dispatch({ type: "RESET" });
    } catch (err) {
      loadingRef.current.complete();
      toast.error(err.message);
    }
  };

  return (
    <form className="w-full flex flex-col gap-y-6" onSubmit={onSubmitHandler}>
      <Input
        label={userType === "buyer" ? "Organization Name" : "Name"}
        type="text"
        className="w-ful"
        Icon={Office}
        required={true}
        value={companyName}
        onChange={(event) => {
          handleInputChange("companyName", event.target.value);
        }}
      />

      <div className="flex justify-between">
        <Input
          label="Email Id"
          type="email"
          className="w-3/4"
          Icon={Mail}
          required={true}
          value={email}
          onChange={(event) => {
            handleInputChange("email", event.target.value);
          }}
          disabled={isCodeSent}
        />
        <Button
          varient="rounded"
          borderColor="blue"
          className={`h-fit w-1/5 py-2.5 self-end font-medium tracking-wider ${isButtonDisabled ? "bg-gray-300 text-white text-sm" : "text-blue-800"}`}
          onClick={onSendCode}
          disabled={isButtonDisabled || isVerified}
        >
           {isCodeSent ? (isButtonDisabled ? `Resend (${timer}s)` : "Re-send") : "Send Code"}
        </Button>
      </div>

      <div className="flex justify-between">
        <Input
          label="Verification code"
          type="number"
          className="w-3/4"
          Icon={Key}
          required={true}
          value={otp}
          onChange={(event) => {
            setOtp(event.target.value);
          }}
          disabled={!isCodeSent || isVerified ? true : false}
        />
        {/* <Button
          disabled={!isCodeSent || isVerified ? true : false}
          onClick={verificationHandler}
          varient="rounded"
          borderColor={isVerified ? "green" : "blue"}
          className={`h-fit w-1/5 py-2.5 self-end font-medium tracking-wider ${
            isVerified ? "text-green-600" : "text-blue-800"
          }`}
        >
          {isVerified ? "Verified" : "Verify"}
        </Button> */}
      </div>

      <Input
        label="Password"
        type="password"
        className="w-full"
        Icon={Eye}
        required={true}
        value={password}
        onChange={(event) => {
          handleInputChange("password", event.target.value);
        }}
      />
      <Input
        label="Re-Type Password"
        type="password"
        className="w-full"
        Icon={Eye}
        required={true}
        value={reTypePassword}
        onChange={(event) => {
          handleInputChange("reTypePassword", event.target.value);
        }}
      />
      <div className="flex">
        <input
          type="checkbox"
          id="terms"
          name="termsAndCondition"
          value="true"
          className="mr-2 border"
          required={true}
        />
        <label htmlFor="terms" className="text-sm font-medium">
          Accept{" "}

          
          <span className="text-blue-800">
             <Link to="/terms"> Terms & Conditions </Link> And <Link to="/privacy"> Privacy policy </Link>{" "}
    
          </span>{" "}
          to proceed
        </label>
      </div>
      <Button
        type="submit"
        color="blue"
        varient="rounded"
        className="w-fit py-2 px-8 mx-auto text-2xl tracking-widest text-white mt-12"
      >
        Create account
      </Button>
    </form>
  );
};

export default SignupForm;
